import {
  Box,
  Button,
  FormControl,
  Grid2,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import SideBar from "../SideBar/SideBar";
import { useTheme, useMediaQuery } from "@mui/material";
import "../Assistant/Assistant.css";
import "./CallHistory.css";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import DeleteIcon from "@mui/icons-material/Delete";
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
// import './ContactList.css'
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
// date
import dayjs from "dayjs";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import SearchIcon from "@mui/icons-material/Search";
import { IconButton } from "@mui/material";
import TablePagination from "@mui/material/TablePagination";
import { getCallHistory } from "../../services/CallHistory";
import Loader from "../Loader";

const rows = [
  createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
  createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
  createData("Eclair", 262, 16.0, 24, 6.0),
  createData("Cupcake", 305, 3.7, 67, 4.3),
  createData("Gingerbread", 356, 16.0, 49, 3.9),
];
function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#2F024E",
    color: "#fff",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 10,
    border: "none",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: "rgba(226, 186, 253, 0.30)",
    border: "none",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: "none",
  },
  "&.MuiTableRow-root:hover": {
    backgroundColor: "rgba(226, 186, 253, 0.30)",
  },
}));

const drawerWidth = 300;

// Voice1
const ITEM_HEIGHTVoice1 = 40;
const ITEM_PADDING_TOPVoice1 = 8;
const MenuPropsVoice1 = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHTVoice1 * 10 + ITEM_PADDING_TOPVoice1,
    },
  },
};
// const namesVoice1 = [
//     'Oliver Hansen',
//     'Van Henry',
//     'April Tucker',
//     'Ralph Hubbard',
//     'Omar Alexander',
//     'Carlos Abbott',
//     'Miriam Wagner',
//     'Bradley Wilkerson',
//     'Virginia Andrews',
//     'Kelly Snyder',
// ];
const namesVoice1 = [];
function getStylesVoice1(nameVoice1, personNameVoice1, themeVoice1) {
  return {
    fontWeight: personNameVoice1.includes(nameVoice1)
      ? themeVoice1.typography.fontWeightMedium
      : themeVoice1.typography.fontWeightRegular,
  };
}

const CallHistory = () => {
  const notify = () => toast.success("Setup Completed");
  const remove = () => toast.success("Deleted successfully");

  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("sm"));

  const [pop, setPop] = useState(false);
  const handlePopOpen = () => setPop(true);
  const handlePopClose = () => setPop(false);

  const navigate = useNavigate();

  // search
  const [searchValue, setSearchValue] = useState("");
  const handleSearch = () => {
    // Add logic to handle search
  };
  // TablePagination-start
  // const [page, setPage] = React.useState(0);
  // const [rowsPerPage, setRowsPerPage] = React.useState(3);

  // TablePagination-start
  const [page, setPage] = useState(0); // Page state (0-based index)
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page state
  const [totalPages, setTotalPages] = useState(0); // Total pages from backend

 
  const handleChangePage = (event, newPage) => {
    setPage(newPage); // Update current page
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value); // Update rows per page
    setPage(0); // Reset to page 0 when rows per page change
  };

  // TablePagination-end

  // Voice1
  const themeVoice1 = useTheme();
  const [personNameVoice1, setPersonNameVoice1] = React.useState([]);
  const handleChangeVoice1 = (event) => {
    const {
      target: { value },
    } = event;
    setPersonNameVoice1(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  const [campaignType, setCampaignType] = useState("All");

  //callhistory
  const [callHistory, setCallHistory] = useState([]);
  // const [startDate, setStartDate] = useState(dayjs().startOf("day")); // Start of today
  // const [endDate, setEndDate] = useState(dayjs().endOf("day"));
  const [startDate, setStartDate] = useState(null); // Initially empty
  const [endDate, setEndDate] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    getAllCallHistory();

    // const intervalId = setInterval(() => {
    //   getAllCallHistoryLoad();
    // }, 10000);

    // return () => clearInterval(intervalId);
  }, []);

  const getAllCallHistoryLoad = async () => {
    const response = await getCallHistory(page+1);
    if (response?.data?.success === true) {
      setCallHistory(response.data.result?.data);
      setTotalPages(response.data.result?.totalPages); // Set the total pages from the backend
    }
  };

  const getAllCallHistory = async () => {
    setIsLoading(true);
    const response = await getCallHistory(page+1);
    if (response?.data?.success === true) {
      setCallHistory(response.data.result?.data);
      setTotalPages(response.data.result?.totalPages); // Set the total pages from the backend

      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllCallHistory(page); // Fetch data on page load or page change
  }, [page, rowsPerPage]);
  const filteredCallHistory = callHistory?.filter((call) => {
    const callDate = dayjs(call.date); // Assuming call.date is in a valid date format
    const isWithinDateRange = callDate.isBetween(
      startDate,
      endDate,
      null,
      "[]"
    );
    const isMatchingCampaignType =
      campaignType === "All" || call?.interest === campaignType;
    return isWithinDateRange && isMatchingCampaignType;
    // return callDate.isBetween(startDate, endDate, null, "[]"); // Inclusive of startDate and endDate
  });

  const displayedRows = filteredCallHistory?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);


  const formatCallDuration = (duration) => {
    // Split the input duration like "1min:12secs" into components
    const [minutes, seconds] = duration.split(":").map((str) => parseInt(str));
    // Return the formatted string
    return `${minutes} min ${seconds} secs`;
  };

  const checkIfDurationGreaterThanOneMinute = (duration) => {
    const [minutes, seconds] = duration.split(":").map((str) => parseInt(str));

    // return minutes > 1 || (minutes === 1 && seconds > 1);
    return minutes > 0 || (minutes === 0 && seconds > 1);
  };

  const formatDate = (date) => {
    // Split the input duration like "1min:12secs" into components
    const formattedDate = dayjs(date).format("MMMM D, hh:mm A");

    // Return the formatted string
    return formattedDate;
  };

  if (isLoading) return <Loader />;

  return (
    <div className="CallHistoryTable">
      {/* <Box sx={{ display: isLgUp ? "flex" : "block", marginTop: "20px" }}>
        <SideBar /> */}
      {/* {isLoading===true &&  <Loader />} */}

      {/* <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: isLgUp ? 5 : 1,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            marginTop: isLgUp ? "0px" : "80px",
          }}
        > */}
      <h3>Call History</h3>
      <Grid2 container spacing={2} sx={{ alignItems: "center" }}>
        <Grid2
          item
          size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
          className="mb-20"
        >
          <Grid2 container spacing={2}>
            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <div className="input-common DatePicker-button">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DemoItem>
                      <label>Start Date</label>
                      {/* <DatePicker defaultValue={dayjs("2022-04-17")} /> */}
                      <DatePicker
                        value={startDate}
                        onChange={(newValue) => setStartDate(newValue)}
                      />
                    </DemoItem>
                  </DemoContainer>
                </LocalizationProvider>
              </div>
            </Grid2>
            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <div className="input-common DatePicker-button">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DemoItem>
                      <label>End Date</label>
                      {/* <DatePicker defaultValue={dayjs("2022-04-17")} /> */}
                      <DatePicker
                        value={endDate}
                        onChange={(newValue) => setEndDate(newValue)}
                      />
                    </DemoItem>
                  </DemoContainer>
                </LocalizationProvider>
              </div>
            </Grid2>
          </Grid2>
        </Grid2>
        {/* <Grid2 item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <Stack
                direction="row"
                sx={{ justifyContent: "end" }}
                className="search-history-input"
              >
                <div className="input-common">
                  <TextField
                    size="small"
                    placeholder="Search History"
                    value={searchValue}
                    className="search-bar"
                    onChange={(e) => setSearchValue(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <IconButton onClick={handleSearch}>
                          <SearchIcon />
                        </IconButton>
                      ),
                    }}
                  />
                </div>
              </Stack>
            </Grid2> */}
        <Grid2 item size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}>
          <div
            className="input-common"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <FormControl fullWidth style={{ marginBottom: 10 }}>
              <label>Select Option</label>
              <Select
                id="campaign type"
                displayEmpty
                value={campaignType}
                input={<OutlinedInput />}
                MenuProps={MenuPropsVoice1}
                inputProps={{ "aria-label": "Without label" }}
                onChange={(e) => setCampaignType(e.target.value)}
              >
                <MenuItem
                  value="All"
                  onClick={(e) => {
                    setCampaignType("All");
                  }}
                >
                  All
                </MenuItem>
                <MenuItem
                  value="Interest"
                  onClick={(e) => {
                    setCampaignType("Interest");
                  }}
                >
                  Warm
                </MenuItem>
                <MenuItem
                  value="NotInterest"
                  onClick={(e) => {
                    setCampaignType("NotInterest");
                  }}
                >
                  Cold{" "}
                </MenuItem>
              </Select>
            </FormControl>
          </div>
        </Grid2>

        <Grid2
          item
          size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          className="mb-20"
        >
          <div className="ContactListTable-main">
            <TableContainer
              component={Paper}
              sx={{ maxHeight: 440, borderRadius: "20px 20px 0px 0px" }}
            >
              <Table
                sx={{ minWidth: 700 }}
                stickyHeader
                aria-label="sticky table"
              >
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">
                      Assistant Name
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      Campaign Name
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      Customer Name
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      Phone Number
                    </StyledTableCell>
                    <StyledTableCell align="center">Status</StyledTableCell>
                    <StyledTableCell align="center">
                      Call Answered
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      Call duration
                    </StyledTableCell>
                    <StyledTableCell align="center">Date</StyledTableCell>
                    <StyledTableCell align="center">
                      Explore More
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {displayedRows?.length > 0 ? (
                    displayedRows.map((row, index) => (
                      <StyledTableRow
                        key={index}
                        onClick={() =>
                          navigate("/campaign-details", {
                            state: { id: row?.callId ,customerName:row?.customerName,status:row?.status,date:row?.date},
                          })
                        }
                        style={{ cursor: "pointer" }}
                      >
                        {/* <StyledTableCell component="th" scope="row"><Link to='/contact-list-view'><h4> {row.assistantName}  </h4> </Link></StyledTableCell> */}
                        <StyledTableCell align="center">
                          <h4>{row.assistantName}</h4>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <h4>{row.campaignName}</h4>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <h4
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                              color: "blue",
                            }}
                          >
                            {row.customerName}
                          </h4>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <h4>{row.phoneNumber}</h4>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <h4 style={{ textTransform: "capitalize" }}>
                            {row.status}
                          </h4>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <h4 className="green">
                            {checkIfDurationGreaterThanOneMinute(row.duration)
                              ? "Yes"
                              : "No"}
                          </h4>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <h4>{formatCallDuration(row.duration)}</h4>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <h4>{formatDate(row.date)}</h4>
                        </StyledTableCell>
                        <StyledTableCell align="center" key={row?.callId}>
                          {" "}
                          <Stack
                            direction="row"
                            spacing={2}
                            sx={{ justifyContent: "center" }}
                          >
                            <div
                              onClick={() =>
                                navigate("/campaign-details", {
                                  state: { id: row?.callId ,customerName:row?.customerName,status:row?.status,date:row?.date},
                                })
                              }
                              style={{ cursor: "pointer" }}
                            >
                              {" "}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="40"
                                height="22"
                                viewBox="0 0 40 22"
                                fill="none"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M1.76172 18.5155C5.6476 15.8802 9.09831 14.3849 12.1138 14.0297C15.1294 13.6744 18.0004 13.6207 20.7268 13.8686L20.7268 18.5879L33.5264 10.8872L20.7268 3.58789L20.7268 8.07333C15.6852 8.09539 11.3991 9.10024 7.86848 11.0879C4.33889 13.0755 2.30331 15.5514 1.76172 18.5155Z"
                                  fill="#707070"
                                  stroke="#707070"
                                  stroke-width="1.76471"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </div>
                          </Stack>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                  ) : (
                    <StyledTableRow style={{ height: 100 }}>
                      <StyledTableCell
                        colSpan={9}
                        style={{ textAlign: "center" }}
                      >
                        <label style={{ fontSize: "15px" }}>
                          No data found!
                        </label>
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <div className="Pagination-main">
              {/* <TablePagination
                                    rowsPerPageOptions={[3, 25, 100]}
                                    component="div"
                                    count={rows.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                /> */}
            {filteredCallHistory?.length > 5 && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredCallHistory.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
            </div>
          </div>
        </Grid2>
      </Grid2>
      {/* </Box> */}
      {/* </Box> */}
    </div>
  );
};

export default CallHistory;
